import { ErrorCode } from './ErrorCode'
import { errorMessages } from './errorMessages'

export class AppError extends Error {
  readonly code: ErrorCode
  readonly userMessage: string
  readonly originalError?: unknown

  constructor(code: ErrorCode, originalError?: unknown) {
    super(errorMessages[code])
    this.name = 'AppError'
    this.code = code
    this.userMessage = errorMessages[code]
    this.originalError = originalError

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, AppError)
    }
  }
}
